"use strict";
const _ = require('lodash');
const { freightCostArticle, handlingCostArticle, srsEUR6PalletArticle, } = require('../../models/article');
const rowIsHandlingCostRow = orderRow => _.get(orderRow, 'article.articleNumber') ===
    handlingCostArticle.articleNumber ||
    _.get(orderRow, 'article.articleNumber') === freightCostArticle.articleNumber;
const rowIsSRSRow = orderRow => _.get(orderRow, 'article.articleNumber') ===
    srsEUR6PalletArticle.articleNumber;
function calculateTotalForRow(row) {
    if (!row.price || !row.deliveredQuantity)
        return 0;
    return _.round(row.deliveredQuantity * row.price * (1 - _.get(row, 'discount', 0) / 100), 2);
}
// this illustrates the problem of having one orderunit on an article and another on the row
function getUnitOnRow(orderRow) {
    const { article } = orderRow;
    if (_.includes(['single', 'package'], article.orderUnit)) {
        return 'single';
    }
    if (article.orderUnit === 'weight') {
        return 'weight';
    }
    return `single`;
}
function getNumberOfOrderUnitsOnRow(orderRow) {
    const { article, deliveredQuantity } = orderRow;
    if (!article)
        return 0;
    if (article.orderUnit === 'single') {
        return deliveredQuantity;
    }
    if (article.orderUnit === 'weight') {
        return deliveredQuantity;
    }
    const colliSize = _.get(article, 'colliSize', 1);
    return (deliveredQuantity || 0) / colliSize;
}
module.exports = {
    rowIsHandlingCostRow,
    rowIsSRSRow,
    calculateTotalForRow,
    getNumberOfOrderUnitsOnRow,
    getUnitOnRow,
};
